import { censorText } from "@yay/shared";
import { useCensorPref } from "../lib/censorPref";

/**
 * Renders text through the visual-only profanity filter when the viewer has
 * it on. Own component so memoized parents (e.g. AvatarTheater) don't need
 * to re-render when the preference changes.
 */
export function Censored({ text }: { text: string | undefined }) {
  const on = useCensorPref();
  const shown = text ?? "";
  return <>{on ? censorText(shown) : shown}</>;
}
